import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import { OBCard } from '../../../Bento/components';
import locales from './locales';

interface SuccessMandateeProps {
  isNewOnboardingAllowed: boolean;
  onNext: () => void;
}

const SuccessMandatee = asBentoPage<SuccessMandateeProps>(
  ({ isNewOnboardingAllowed, Layout, onNext }) => (
    <Layout data-testid="success-mandatee" nav={<OBNavigation />}>
      <OBCard>
        <OBCard.Body>
          <Heading marginBottom="space-16" textAlign="center">
            {locales.title}
          </Heading>

          <Text marginBottom="space-24">{locales.description}</Text>

          {!isNewOnboardingAllowed ? (
            <Callout>
              <Callout.Content>{locales.info}</Callout.Content>
            </Callout>
          ) : null}
        </OBCard.Body>
        <OBCard.Footer>
          <Button isExpanded onClick={onNext}>
            {locales.next}
          </Button>
        </OBCard.Footer>
      </OBCard>
    </Layout>
  ),
);

export default SuccessMandatee;
